import { toString as toString_1, Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { option_type, obj_type, anonRecord_type, record_type, lambda_type, unit_type, bool_type, union_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { LoginResponse_$reflection, LoginRequest_$reflection, LoginRequest, GenericResponse_$reflection } from "./Shared/ApiDataTypes.js";
import { FetchError, FetchError_$reflection } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { email as email_1 } from "./Shared/Validate.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { unwrap, map, defaultArg, some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "./Promises.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton, cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, equals, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Alert, Typography, Link, CircularProgress, ToggleButton, ToggleButtonGroup, Checkbox, FormControlLabel, Paper, DialogActions, Button, DialogContent, TextField, DialogTitle, Dialog, DialogContentText } from "@mui/material";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { StyleCreator$1_$ctor, StyleImports_makeStyles_get } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Styles.fs.js";
import { StyleCreator$1__create_4EAC9E1E } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Styles.fs.js";
import { createElement } from "react";
import React from "react";
import { ctx as ctx_1 } from "./Context.js";
import { empty as empty_1, append, singleton as singleton_1, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { tryFocus, SnackError, loadingIndicatorSmall } from "./ViewHelpers.js";
import { deleteRememberMe, storeRememberMe, tryGetRememberMe } from "./LocalStorage.js";
import { isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { Localization_Language, Localization_Language_FromString_Z721C83C5 } from "./Shared/Shared.js";

class RecoveryRequestForm_Step extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EmailStep", "FailedStep", "CompletedStep"];
    }
}

function RecoveryRequestForm_Step_$reflection() {
    return union_type("Login.RecoveryRequestForm.Step", [], RecoveryRequestForm_Step, () => [[], [["Item", string_type]], []]);
}

class RecoveryRequestForm_Model extends Record {
    constructor(Email, CurrentStep, ValidEmail, Processing, OnClose) {
        super();
        this.Email = Email;
        this.CurrentStep = CurrentStep;
        this.ValidEmail = ValidEmail;
        this.Processing = Processing;
        this.OnClose = OnClose;
    }
}

function RecoveryRequestForm_Model_$reflection() {
    return record_type("Login.RecoveryRequestForm.Model", [], RecoveryRequestForm_Model, () => [["Email", string_type], ["CurrentStep", RecoveryRequestForm_Step_$reflection()], ["ValidEmail", bool_type], ["Processing", bool_type], ["OnClose", lambda_type(unit_type, unit_type)]]);
}

class RecoveryRequestForm_Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateEmail", "GotoStep", "InvalidateEmail", "Commit", "ResetResponse", "SetError", "DismissError"];
    }
}

function RecoveryRequestForm_Message_$reflection() {
    return union_type("Login.RecoveryRequestForm.Message", [], RecoveryRequestForm_Message, () => [[["Item", string_type]], [["Item", RecoveryRequestForm_Step_$reflection()]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [GenericResponse_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", GenericResponse_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", string_type]], []]);
}

function RecoveryRequestForm_init(x) {
    return new RecoveryRequestForm_Model("", new RecoveryRequestForm_Step(0, []), true, false, x);
}

function RecoveryRequestForm_update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new RecoveryRequestForm_Model(model.Email, msg.fields[0], model.ValidEmail, model.Processing, model.OnClose);
        case 2:
            return new RecoveryRequestForm_Model(model.Email, model.CurrentStep, false, model.Processing, model.OnClose);
        case 3:
            if (email_1(model.Email)) {
                return new RecoveryRequestForm_Model(model.Email, model.CurrentStep, true, true, model.OnClose);
            }
            else {
                return new RecoveryRequestForm_Model(model.Email, model.CurrentStep, false, model.Processing, model.OnClose);
            }
        case 4: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                return new RecoveryRequestForm_Model(model.Email, new RecoveryRequestForm_Step(1, ["Kunne ikke starte tilbakestilling av passord. Vennligst prøv igjen senere."]), model.ValidEmail, false, model.OnClose);
            }
            else {
                const x_2 = res.fields[0];
                if (x_2.Result === "success") {
                    return new RecoveryRequestForm_Model(model.Email, new RecoveryRequestForm_Step(2, []), model.ValidEmail, model.Processing, model.OnClose);
                }
                else {
                    return new RecoveryRequestForm_Model(model.Email, new RecoveryRequestForm_Step(1, [x_2.Message]), model.ValidEmail, false, model.OnClose);
                }
            }
        }
        case 5:
            return new RecoveryRequestForm_Model(model.Email, new RecoveryRequestForm_Step(1, [msg.fields[0]]), model.ValidEmail, model.Processing, model.OnClose);
        case 6:
            return new RecoveryRequestForm_Model(model.Email, new RecoveryRequestForm_Step(0, []), model.ValidEmail, model.Processing, model.OnClose);
        default:
            return new RecoveryRequestForm_Model(msg.fields[0], model.CurrentStep, model.ValidEmail, model.Processing, model.OnClose);
    }
}

function RecoveryRequestForm_requestReset(email, dispatch) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let item, body, decoder, data_1, caseStrategy_3, extra_3;
        dispatch(new RecoveryRequestForm_Message(3, []));
        return ((item = {
            Email: email,
        }, (body = Auto_generateBoxedEncoder_437914C6(anonRecord_type(["Email", string_type]), undefined, undefined, undefined)(item), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/password-recovery/request", properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))))).then((_arg_2) => {
            dispatch(new RecoveryRequestForm_Message(4, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

function RecoveryRequestForm_failed(errMsg) {
    return MuiHelpers_createElement(DialogContentText, [["children", reactApi.Children.toArray([errMsg])]]);
}

const RecoveryRequestForm_useStyles = StyleImports_makeStyles_get((() => {
    let f1;
    const styles = StyleCreator$1_$ctor();
    f1 = ((_arg) => ({
        paper: StyleCreator$1__create_4EAC9E1E(styles, singleton(["backgroundColor", "#FFFFFF"])),
    }));
    return (arg) => {
        const o = f1(arg);
        return Object.assign({}, o);
    };
})());

export function RecoveryRequestForm_RecoveryForm(recoveryRequestForm_RecoveryFormInputProps) {
    let elements_2, children_2, children_3;
    const onClose = recoveryRequestForm_RecoveryFormInputProps.onClose;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = RecoveryRequestForm_init(onClose);
    patternInput = reactApi.useReducer(RecoveryRequestForm_update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_1, v) => {
        model_1.OnClose();
    }], ["PaperProps", {
        className: RecoveryRequestForm_useStyles().paper,
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("PasswordRecovery.ForgotPw")]]), (children_2 = toList(delay(() => {
        let children;
        const matchValue = model_1.CurrentStep;
        return (matchValue.tag === 1) ? singleton_1(RecoveryRequestForm_failed(matchValue.fields[0])) : ((matchValue.tag === 2) ? singleton_1(MuiHelpers_createElement(DialogContentText, [["children", ctx.Locale.t("PasswordRecovery.Instructions")]])) : singleton_1((children = ofArray([MuiHelpers_createElement(DialogContentText, [["children", ctx.Locale.t("PasswordRecovery.Description")]]), MuiHelpers_createElement(TextField, toList(delay(() => append(singleton_1(["id", "recovery-email"]), delay(() => append(singleton_1(["defaultValue", model_1.Email]), delay(() => append(singleton_1(["error", !model_1.ValidEmail]), delay(() => append(!model_1.ValidEmail ? singleton_1(["helperText", ctx.Locale.t("Login.InvalidEmail")]) : empty_1(), delay(() => append(singleton_1(["onChange", (e) => {
            dispatch(new RecoveryRequestForm_Message(0, [e.target.value]));
        }]), delay(() => append(singleton_1(["variant", "outlined"]), delay(() => append(singleton_1(["autoFocus", true]), delay(() => append(singleton_1(["label", ctx.Locale.t("Login.Email")]), delay(() => append(singleton_1(["type", "email"]), delay(() => singleton_1(["fullWidth", true]))))))))))))))))))))))]), createElement("div", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))));
    })), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children_2))]])), (children_3 = toList(delay(() => append(singleton_1(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_2) => {
        onClose();
    }]])), delay(() => (equals(model_1.CurrentStep, new RecoveryRequestForm_Step(0, [])) ? (model_1.Processing ? singleton_1(loadingIndicatorSmall()) : singleton_1(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["disabled", model_1.Email.length === 0], ["children", ctx.Locale.t("Next")], ["onClick", (_arg_3) => {
        if (email_1(model_1.Email) && !model_1.Processing) {
            RecoveryRequestForm_requestReset(model_1.Email, dispatch);
        }
        else {
            dispatch(new RecoveryRequestForm_Message(2, []));
        }
    }]]))) : empty_1()))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_3))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

class LoginView extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Credentials", "TFA"];
    }
}

function LoginView_$reflection() {
    return union_type("Login.LoginView", [], LoginView, () => [[], [["Item", string_type]]]);
}

class Model extends Record {
    constructor(CurrentView, Username, Password, Code, Remembered, ErrorMsg) {
        super();
        this.CurrentView = CurrentView;
        this.Username = Username;
        this.Password = Password;
        this.Code = Code;
        this.Remembered = Remembered;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Login.Model", [], Model, () => [["CurrentView", LoginView_$reflection()], ["Username", string_type], ["Password", string_type], ["Code", string_type], ["Remembered", bool_type], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateUsername", "UpdatePassword", "UpdateCode", "SetView", "SetError"];
    }
}

function Message_$reflection() {
    return union_type("Login.Message", [], Message, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", LoginView_$reflection()]], [["Item", option_type(string_type)]]]);
}

function init() {
    const rememberState = tryGetRememberMe();
    return new Model(new LoginView(0, []), defaultArg(rememberState, ""), "", "", rememberState != null, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.CurrentView, model.Username, msg.fields[0], model.Code, model.Remembered, model.ErrorMsg);
        case 2:
            return new Model(model.CurrentView, model.Username, model.Password, msg.fields[0], model.Remembered, model.ErrorMsg);
        case 3:
            return new Model(msg.fields[0], model.Username, model.Password, "", model.Remembered, model.ErrorMsg);
        case 4:
            return new Model(model.CurrentView, model.Username, model.Password, model.Code, model.Remembered, msg.fields[0]);
        default:
            return new Model(model.CurrentView, msg.fields[0], model.Password, model.Code, model.Remembered, model.ErrorMsg);
    }
}

export function Login(loginInputProps) {
    let elems_10, elems_9;
    const onLoginSuccess = loginInputProps.onLoginSuccess;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setForgotPassword = patternInput_1[1];
    const forgotPasswordForm = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setProcessing = patternInput_2[1];
    const processing = patternInput_2[0];
    let patternInput_3;
    const initial_2 = tryGetRememberMe() != null;
    patternInput_3 = reactApi.useState(initial_2);
    const remember = patternInput_3[0];
    const patternInput_4 = reactApi.useState(false);
    const pushLocale = patternInput_4[0];
    const tryLogin = (username, password) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let body, decoder, data_1, caseStrategy_3, extra_3;
        setProcessing(true);
        const req = new LoginRequest(username, password);
        const requestPath = "/api/auth/login" + (!pushLocale ? "" : (`?locale=${toString_1(ctx.Language)}`));
        return ((body = Auto_generateBoxedEncoder_437914C6(LoginRequest_$reflection(), undefined, undefined, undefined)(req), (decoder = Auto_generateBoxedDecoder_Z6670B51(LoginResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(LoginResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg_2) => (new FSharpResult$2(1, [new FetchError(3, [arg_2])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })())))))).then((_arg_2) => {
            let x_1, matchValue_1;
            const res = _arg_2;
            return ((res.tag === 0) ? ((x_1 = res.fields[0], (x_1.Result === "success") ? ((matchValue_1 = x_1.Session, (matchValue_1 == null) ? ((dispatch(new Message(4, [ctx.Locale.t("Login.LoginFailed")])), Promise.resolve())) : ((onLoginSuccess(matchValue_1), Promise.resolve())))) : ((x_1.Result === "progress") ? ((dispatch(new Message(3, [new LoginView(1, [x_1.Message])])), (setProcessing(false), Promise.resolve()))) : ((dispatch(new Message(4, [x_1.Message])), Promise.resolve()))))) : ((dispatch(new Message(4, [ctx.Locale.t("Login.LoginFailed")])), Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                setProcessing(false);
                return Promise.resolve();
            }));
        });
    }));
    return createElement("div", createObj(ofArray([["style", {
        height: 100 + "vh",
        width: 100 + "vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(37, 55, 70, 0.75)",
    }], (elems_10 = [createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(4, [undefined]));
        },
    }), MuiHelpers_createElement(Paper, [["style", {
        width: 80 + "vw",
        maxWidth: 350,
        padding: 20,
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px",
    }], (elems_9 = toList(delay(() => append(forgotPasswordForm ? singleton_1(createElement(RecoveryRequestForm_RecoveryForm, {
        onClose: () => {
            setForgotPassword(false);
        },
    })) : empty_1(), delay(() => {
        let elems;
        return append(singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "center",
            padding: ((20 + "px ") + 0) + "px",
            backgroundColor: "hsl(207.3, 30.8%, 21%)",
            borderRadius: 5,
        }], (elems = [createElement("img", {
            src: "/logo.png",
            style: {
                width: 100 + "%",
                maxWidth: 200,
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_6, elems_3, elements_1, elems_5, elems_4;
            const matchValue_4 = model_1.CurrentView;
            return (matchValue_4.tag === 0) ? append(singleton_1(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 8 + "px",
            }], (elems_6 = [MuiHelpers_createElement(TextField, [["key", "email-input"], ["id", "email-input"], ["fullWidth", true], ["autoFocus", !model_1.Remembered], ["defaultValue", model_1.Username], ["label", ctx.Locale.t("Login.Email")], ["variant", "outlined"], ["onChange", (e_1) => {
                dispatch(new Message(0, [e_1.target.value]));
            }], ["onKeyUp", (kc) => {
                kc.preventDefault();
                if (kc.key === "Enter") {
                    tryFocus("pwd-input");
                }
            }]]), MuiHelpers_createElement(TextField, [["key", "pwd-input"], ["id", "pwd-input"], ["fullWidth", true], ["label", ctx.Locale.t("Login.Password")], ["autoFocus", model_1.Remembered], ["variant", "outlined"], ["type", "password"], ["onChange", (e_2) => {
                dispatch(new Message(1, [e_2.target.value]));
            }], ["onKeyUp", (kc_1) => {
                kc_1.preventDefault();
                if ((kc_1.key === "Enter") && !processing) {
                    if (!isNullOrWhiteSpace(model_1.Username) && !isNullOrWhiteSpace(model_1.Password)) {
                        if (remember) {
                            storeRememberMe(model_1.Username);
                        }
                        const pr_3 = tryLogin(model_1.Username, model_1.Password);
                        pr_3.then();
                    }
                }
            }]]), createElement("div", createObj(ofArray([["style", {
                display: "flex",
            }], (elems_3 = [MuiHelpers_createElement(FormControlLabel, [["style", {
                flexGrow: 1,
            }], ["label", ctx.Locale.t("Login.RememberMe")], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"], ["checked", remember], ["onChange", (e_3) => {
                const x_4 = e_3.target.checked;
                if (x_4) {
                    storeRememberMe(model_1.Username);
                }
                else {
                    deleteRememberMe();
                }
                patternInput_3[1](x_4);
            }]])]]), MuiHelpers_createElement(ToggleButtonGroup, [["size", "small"], ["exclusive", true], ["value", toString_1(ctx.Language)], ["onChange", (_arg_9, v) => {
                ctx.SetLanguage(Localization_Language_FromString_Z721C83C5(v));
                patternInput_4[1](true);
            }], (elements_1 = [MuiHelpers_createElement(ToggleButton, [["value", toString_1(new Localization_Language(0, []))], ["children", "NO"]]), MuiHelpers_createElement(ToggleButton, [["value", toString_1(new Localization_Language(1, []))], ["children", "EN"]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), MuiHelpers_createElement(Button, [["fullWidth", true], ["color", "primary"], ["variant", "contained"], ["disabled", isNullOrWhiteSpace(model_1.Username) ? true : isNullOrWhiteSpace(model_1.Password)], (elems_5 = [createElement("span", createObj(ofArray([["style", {
                height: 2 + "em",
            }], (elems_4 = toList(delay(() => (!processing ? singleton_1(ctx.Locale.t("Login.Signin")) : singleton_1(MuiHelpers_createElement(CircularProgress, [["color", "inherit"], ["size", 2 + "em"]]))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))]), ["style", createObj(toList(delay(() => append(singleton_1(["backgroundColor", "hsl(207.3, 30.8%, 21%)"]), delay(() => append(singleton_1(["color", "#FFFFFF"]), delay(() => ((isNullOrWhiteSpace(model_1.Username) ? true : isNullOrWhiteSpace(model_1.Password)) ? singleton_1(["opacity", 0.5]) : empty_1()))))))))], ["onClick", (_arg_10) => {
                if ((!isNullOrWhiteSpace(model_1.Username) && !isNullOrWhiteSpace(model_1.Password)) && !processing) {
                    if (remember) {
                        storeRememberMe(model_1.Username);
                    }
                    const pr_4 = tryLogin(model_1.Username, model_1.Password);
                    pr_4.then();
                }
            }]])], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                let elems_7;
                return append(singleton_1(MuiHelpers_createElement(Link, [["style", {
                    cursor: "pointer",
                    width: "max-content",
                    fontSize: 0.8 + "rem",
                }], ["onClick", (_arg_11) => {
                    setForgotPassword(!forgotPasswordForm);
                }], (elems_7 = [MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("Login.ForgotPw")]])], ["children", reactApi.Children.toArray(Array.from(elems_7))])])), delay(() => {
                    let elements_2;
                    return singleton_1(MuiHelpers_createElement(Alert, [["severity", "info"], (elements_2 = [MuiHelpers_createElement(Link, [["href", "https://kunde.kuldeteknisk.no/KundeWeb/Login.aspx"], ["children", ctx.Locale.t("Login.OldKundeweb")]]), MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("Login.OldKundewebInfo")]])], ["children", reactApi.Children.toArray(Array.from(elements_2))])]));
                }));
            })) : append(singleton_1(createElement("span", {
                style: {
                    textAlign: "center",
                    fontSize: 0.8 + "rem",
                },
                children: ctx.Locale.t("Login.EnterTFA"),
            })), delay(() => append(singleton_1(MuiHelpers_createElement(TextField, [["key", "code-input"], ["id", "code-input"], ["label", ctx.Locale.t("Login.Code")], ["variant", "outlined"], ["onChange", (e) => {
                dispatch(new Message(2, [e.target.value]));
            }], ["style", {
                margin: ((5 + "px ") + 0) + "px",
            }]])), delay(() => {
                let elements;
                return singleton_1(MuiHelpers_createElement(Button, [["fullWidth", true], ["variant", "contained"], ["disabled", model_1.Code.length === 0], (elements = toList(delay(() => (processing ? singleton_1(loadingIndicatorSmall()) : singleton_1(ctx.Locale.t("Login.Verify"))))), ["children", reactApi.Children.toArray(Array.from(elements))]), ["style", createObj(toList(delay(() => append(singleton_1(["marginTop", 10]), delay(() => append(singleton_1(["backgroundColor", "hsl(207.3, 30.8%, 21%)"]), delay(() => append(singleton_1(["color", "#FFFFFF"]), delay(() => (isNullOrWhiteSpace(model_1.Code) ? singleton_1(["opacity", 0.3]) : empty_1()))))))))))], ["onClick", (_arg_8) => {
                    if (!isNullOrWhiteSpace(model_1.Code) && !processing) {
                        const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                            let item_1, body_3, decoder_3, data_5, caseStrategy_12, extra_12;
                            setProcessing(true);
                            const url_3 = "/api/auth/tfa-login" + (!pushLocale ? "" : (`?locale=${toString_1(ctx.Language)}`));
                            return ((item_1 = {
                                Code: model_1.Code.trim(),
                                Cookie: matchValue_4.fields[0],
                            }, (body_3 = Auto_generateBoxedEncoder_437914C6(anonRecord_type(["Code", string_type], ["Cookie", string_type]), undefined, undefined, undefined)(item_1), (decoder_3 = Auto_generateBoxedDecoder_Z6670B51(LoginResponse_$reflection(), undefined, undefined), (data_5 = some(body_3), (caseStrategy_12 = undefined, (extra_12 = undefined, (() => {
                                let properties_6;
                                try {
                                    const properties_3_1 = Helper_withProperties(corsProps, (properties_6 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_12), unwrap(extra_12))(data_1_2))]), properties_6), data_5), properties_6)));
                                    const pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url_3, properties_3_1).then((_arg_3) => {
                                        let response_3, decoder_1_2;
                                        return ((response_3 = _arg_3, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(LoginResponse_$reflection(), unwrap(caseStrategy_12), unwrap(extra_12))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_4) => {
                                            let matchValue_2;
                                            return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_2), _arg_4), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                                    }))));
                                    return pr_1.then(void 0, ((arg_9) => (new FSharpResult$2(1, [new FetchError(3, [arg_9])]))));
                                }
                                catch (exn_1) {
                                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                                }
                            })()))))))).then((_arg_5) => {
                                let matchValue_3;
                                const res_1 = _arg_5;
                                if (res_1.tag === 0) {
                                    const x_3 = res_1.fields[0];
                                    return ((x_3.Result === "success") ? ((matchValue_3 = x_3.Session, (matchValue_3 == null) ? ((dispatch(new Message(4, [ctx.Locale.t("Login.LoginFailed")])), Promise.resolve())) : ((onLoginSuccess(matchValue_3), Promise.resolve())))) : ((dispatch(new Message(4, [x_3.Message])), Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                                        setProcessing(false);
                                        return Promise.resolve();
                                    }));
                                }
                                else {
                                    dispatch(new Message(4, [ctx.Locale.t("Login.LoginFailed")]));
                                    setProcessing(false);
                                    return Promise.resolve();
                                }
                            });
                        }));
                        pr_2.then();
                    }
                }]]));
            }))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_9))])])], ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
}

